import { render } from "./App.vue?vue&type=template&id=c535f9da"
const script = {}

import exportComponent from "C:\\Users\\jimmy.y.chen\\Desktop\\教學中心source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__